export const taskItem = {
	group: "taskItem",
	content: "paragraph block*",
	defining: true,
	attrs: { checked: { default: false } },
};
